import { Component, input, InputSignal } from '@angular/core';

import { StaticBlockWithTagsSection } from '@core/cms/landing.cms';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';

/**
 * Renders a `ComponentSectionStaticBlockWithTags`: a static content block paired with a tags block
 * (intro content + a list of tag chips).
 */
@Component({
    selector: 'cms-static-block-with-tags',
    imports: [TrustHtmlPipe],
    templateUrl: './static-block-with-tags.html',
    styleUrl: './static-block-with-tags.scss',
})
export class CmsStaticBlockWithTags {
    public readonly section: InputSignal<StaticBlockWithTagsSection> =
        input.required<StaticBlockWithTagsSection>();
}
